if (!customElements.get('testimonial-slider')) {
  customElements.define(
    'testimonial-slider',
    class TestimonialSlider extends HTMLElement {
      constructor() {
        super();
        const nestedSlider = this.querySelector("slideshow-component")
        nestedSlider.addEventListener("slideChanged", (e) => {
          this.onSlideChange(e.detail.currentPage)
        })
      }
      onSlideChange(slideIndex) {
        const zeroBasedIndex = Number(slideIndex) - 1
        const contents = this.querySelectorAll(".testimonials__content");
        const contentTrack = this.querySelector(".testimonials__contents-track")

        if (contentTrack && contents) {
          const existingTransitionTime = getComputedStyle(contentTrack).getPropertyValue('--transition-time');
          const transitionTime = Number(existingTransitionTime.replace('s', '')) * 1000

          contents.forEach(content => content.classList.add('hide-animation'))

          setTimeout(() => {
            contentTrack.style.setProperty('--transform-left-multiplier', zeroBasedIndex)
            //Double adding hide-animation class as there is flashed content when user slides multiple slides at once
            contents.forEach(content => content.classList.add('hide-animation'))
            contents[zeroBasedIndex].classList.remove('hide-animation')
          }, transitionTime);
        }
      } 
    }
  );
}
